const AI_BUILDER_PROTOCOL_VERSION = 1
const AI_BUILDER_IFRAME_NAME = 'izteach-ai-builder'
const AI_BUILDER_EMBED_QUERY = 'embed'
const AI_BUILDER_EMBED_VALUE = 'site-builder'
const AI_BUILDER_MAX_SOURCE_CHARS = 500000

const AI_BUILDER_MESSAGE = {
  HELLO: 'izteach-ai-builder:hello',
  READY: 'izteach-ai-builder:ready',
  APPLY: 'izteach-ai-builder:apply',
  APPLIED: 'izteach-ai-builder:applied',
  APPLY_REJECTED: 'izteach-ai-builder:apply-rejected',
}

function readApplyMessage(data) {
  if (!data || typeof data !== 'object') return {ok: false, reason: 'invalid-payload'}
  if (data.type !== AI_BUILDER_MESSAGE.APPLY) return {ok: false, reason: 'invalid-payload'}
  const payload = data.payload
  if (!payload || payload.protocolVersion !== AI_BUILDER_PROTOCOL_VERSION) {
    return {ok: false, reason: 'invalid-payload'}
  }
  if (typeof payload.sourceHtml !== 'string') return {ok: false, reason: 'invalid-payload'}
  return {ok: true, sourceHtml: payload.sourceHtml}
}

module.exports = {
  AI_BUILDER_PROTOCOL_VERSION,
  AI_BUILDER_IFRAME_NAME,
  AI_BUILDER_EMBED_QUERY,
  AI_BUILDER_EMBED_VALUE,
  AI_BUILDER_MAX_SOURCE_CHARS,
  AI_BUILDER_MESSAGE,
  readApplyMessage,
}
